export const toxins = [
  "Sodium nitrate",
  "Sulfites",
  "Azodicarbonamide",
  "Potassium bromate",
  "Propyl gallate",
  "BHA",
  "BHT",
  "Propylene glycol",
  "Butane",
  "Monosodium glutamate",
  "MSG",
  "Disodium inosinate",
  "Disodium guanylate",
  "Enriched flour",
  "Recombinant Bovine Growth Hormone",
  "rBGH",
  "Refined vegetable oil",
  "Sodium benzoate",
  "Brominated vegetable oil",
  "Propyl gallate",
  "Olestra",
  "Carrageenan",
  "Polysorbate 60",
  "Camauba wax",
  "Magnesium sulphate",
  "Chlorine dioxide",
  "Paraben",
  "Sodium carboxymethyl cellulose",
  "Aluminum",
  "Saccharin",
  "Aspartame",
  "High fructose corn syrup",
  "Acesulfame potassium",
  "Sucralose",
  "Agave nectar",
  "Bleached starch",
  "Tert butylhydroquinone",
  "Red 40",
  "Blue 1",
  "Blue 2",
  "Citrus red 1",
  "Green 3",
  "Yellow 5",
  "Yellow 6",
  "Red 2",
  "Red 3",
  "Caramel coloring",
  "Brown HT",
  "Orange B",
  "Bixin",
  "Norbixin",
  "Annatto"
];
export const addedSugars = [
  "Dextrose",
  "Fructose",
  "Galactose",
  "Glucose",
  "Lactose",
  "Maltose",
  "Sucrose",
  "Beet sugar",
  "Brown sugar",
  "Cane juice crystals",
  "Cane sugar",
  "Castor sugar",
  "Coconut sugar",
  "Confectioner's sugar",
  "powdered sugar",
  "Corn syrup solids",
  "Crystalline fructose",
  "Date sugar",
  "Demerara sugar",
  "Dextrin",
  "Diastatic malt",
  "Ethyl maltol",
  "Florida crystals",
  "Golden sugar",
  "Glucose syrup solids",
  "Grape sugar",
  "Icing sugar",
  "Maltodextrin",
  "Muscovado sugar",
  "Panela sugar",
  "Raw sugar",
  "Sugar",
  "Granulated sugar",
  "Sucanat",
  "Turbinado sugar",
  "Yellow sugar",
  "Agave Nectar",
  "Barley malt",
  "Blackstrap molasses",
  "Brown rice syrup",
  "Buttered sugar",
  "buttercream",
  "Caramel",
  "Carob syrup",
  "Corn syrup",
  "Evaporated cane juice",
  "Fruit juice",
  "Fruit juice concentrate",
  "Golden syrup",
  "High-Fructose Corn Syrup",
  "High Fructose Corn Syrup",
  "HFCS",
  "Honey",
  "Invert sugar",
  "Malt syrup",
  "Maple syrup",
  "Molasses",
  "Rice syrup",
  "Refiner's syrup",
  "Sorghum syrup",
  "Treacle"
];
export const gluten = [
  "Triticum vulgare",
  "Wheat",
  "Rye",
  "Triticale",
  "Barley",
  "Hordeum vulgare",
  "Secale cereale",
  "Triticum spelta",
  "spelt",
  "Wheat protein",
  "hydrolyzed wheat protein",
  "Wheat starch",
  "hydrolyzed wheat starch",
  "Wheat flour",
  "bread flour",
  "bleached flour",
  "Bulgur",
  "Malt",
  "Couscous",
  "Farina",
  "Pasta",
  "Seitan",
  "Wheat grass",
  "Barley grass",
  "Wheat germ oil",
  "Wheat germ extract",
  "Vegetable protein",
  "hydrolyzed vegetable protein",
  "corn",
  "soy",
  "Modified starch",
  "modified food starch",
  "Natural flavor",
  "natural flavoring",
  "Artificial flavor",
  "artificial flavoring",
  "Caramel color",
  "Modified food starch",
  "Hydrolyzed plant protein",
  "HPP",
  "Hydrolyzed vegetable protein",
  "HVP",
  "Seasonings",
  "Flavorings",
  "Vegetable starch",
  "Dextrin",
  "maltodextrin"
];
export const nuts = [
  "Almonds",
  "Brazil nuts",
  "Cashews",
  "Chestnuts",
  "Filberts",
  "Hazelnuts",
  "Hickory nuts",
  "Macadamia nuts",
  "Pecans",
  "Pistachios",
  "Walnuts",
  "Nut butter",
  "Almond butter",
  "cashew butter",
  "peanut butter",
  "marzipan paste",
  "marzipan",
  "nougat",
  "almond paste",
  "peanut oil",
  "peanut flour",
  "almond extract"
];
export const vegan = [
  "beef",
  "lamb",
  "pork",
  "meat",
  "veal",
  "horse",
  "organ meat",
  "wild meat",
  "chicken",
  "turkey",
  "goose",
  "duck",
  "quail",
  "bacon",
  "rabbit",
  "ham",
  "lamb",
  "mutton",
  "pheasant",
  "venison",
  "poultry",
  "sausage",
  "red meat",
  "goose",
  "bison",
  "steak",
  "salami",
  "anchovy",
  "cod",
  "salmon",
  "trout",
  "tilapia",
  "catfish",
  "E120",
  "E322",
  "E422",
  "E471",
  "E542",
  "E631",
  "E901",
  "E904",
  "Cochineal",
  "carmine",
  "Gelatin",
  "Isinglass",
  "Natural flavorings",
  "whey",
  "casein",
  "lactose"
];
export const vegitarian = [
  "beef",
  "lamb",
  "pork",
  "meat",
  "veal",
  "horse",
  "organ meat",
  "wild meat",
  "chicken",
  "turkey",
  "goose",
  "duck",
  "quail",
  "bacon",
  "rabbit",
  "ham",
  "lamb",
  "mutton",
  "pheasant",
  "venison",
  "poultry",
  "sausage",
  "red meat",
  "goose",
  "bison",
  "steak",
  "salami",
  "anchovy",
  "cod",
  "salmon",
  "trout",
  "tilapia",
  "catfish"
];
export const oils = [
  "Vegetable oil",
  "Canola oil",
  "Cottonseed oil",
  "Safflower oil",
  "Soybean oil",
  "Sunflower oil",
  "Corn oil",
  "Peanut oil",
  "Sesame oil"
];
export const labels = [
  "Toxins:",
  "Added sugars:",
  "Gluten:",
  "Nuts:",
  "Non Vegan:",
  "Non Vegitarian:",
  "Bad oils:"
];
export const categories = [
  "Non toxic",
  "Low Added Sugars",
  "Gluten Free",
  "Nut Free",
  "Vegan",
  "Vegitarian",
  "Bad oils"
];
export const checks = [false, false, false, false, false, false, false];
